import { Mark } from '@tiptap/core';

declare module '@tiptap/core' {
  interface Commands<ReturnType> {
    customUnderline: {
      /**
       * Toggle custom underline styling with data-spotstyle
       */
      toggleCustomUnderline: (isActive: boolean, value: string) => ReturnType;
      /**
       * Set custom underline mark
       */
      setCustomUnderline: (name: string, value: string) => ReturnType;
      /**
       * Unset custom underline mark
       */
      unsetCustomUnderline: () => ReturnType;
      /**
       * Unset underline styling
       */
      unsetUnderline: () => ReturnType;
    };
  }
}

export const CustomUnderline = Mark.create({
  name: 'customUnderline',

  addOptions() {
    return {
      HTMLAttributes: {},
    };
  },

  addAttributes() {
    return {
      'data-spotstyle': {
        default: null,
        parseHTML: (element) => element.getAttribute('data-spotstyle'),
        renderHTML: (attributes) => {
          if (!attributes['data-spotstyle']) return {};
          return { 'data-spotstyle': attributes['data-spotstyle'] };
        },
      },
    };
  },

  parseHTML() {
    return [
      {
        tag: 'span',
      },
      {
        tag: 'i',
        getAttrs: (node) => (node as HTMLElement).style.fontStyle !== 'normal' && null,
      },
    ];
  },

  renderHTML({ HTMLAttributes }) {
    return ['span', { ...this.options.HTMLAttributes, ...HTMLAttributes }, 0];
  },

  addCommands() {
    return {
      setCustomUnderline: (name, value) => {
        return ({ commands }) => {
          return commands.setMark(name, { 'data-spotstyle': value });
        };
      },
      unsetCustomUnderline: () => {
        return ({ commands }) => {
          return commands.unsetMark(this.name);
        };
      },
      unsetUnderline: () => {
        return ({ commands }) => {
          return commands.unsetMark(this.name);
        };
      },
      toggleCustomUnderline: (isActive: boolean, value: string) => {
        return ({ editor }) => {
          if (isActive) {
            return editor.chain().focus().setCustomUnderline('customUnderline', value).run();
          }

          return editor.chain().focus().unsetCustomUnderline().run();
        };
      },
    };
  },
});
